import React from "react";
import { Modal } from "react-bootstrap";
import { Switch, Row, Col, Spin } from "antd";

const PrivacyModal = ({ openPrivacy, setOpenPrivacy }) => {
  const onHide = () => {
    setOpenPrivacy(false);
  };
  return (
    <>
      <Modal show={openPrivacy} onHide={onHide} size="xxl" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">KHUB: Privacy Policy</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <div style={{ maxHeight: "500px", overflowY: "auto" }}>
              <p style={{ fontSize: "17px", fontWeight: "600" }}>Welcome to KHUB!</p>
              <p>This Privacy Policy governs your use of KHUB. We respect your privacy and are committed to protecting your personal information.</p>
              <p className="privacy_p">1. Information We Collect</p>
              <ul>
                <li>
                  Personal Identification Information: This includes, but is not limited to, your full name, email address, and contact number, required for
                  login and support purposes.
                </li>
                <li>Usage Data: We collect data related to your interactions with the product, such as order creation and fulfillment.</li>
                <li>
                  Device Information: We may collect information about the device you use to access our product, including the hardware model and operating
                  system.
                </li>
              </ul>
              <p className="privacy_p">2. How We Use Your Information</p>
              <p>We use the collected information for various purposes:</p>
              <ul>
                <li>To provide and maintain our services</li>
                <li>To improve the functionality of our services.</li>
                <li>To provide customer support.</li>
                <li>To gather analysis or valuable information to improve our product.</li>
                <li>To detect, prevent, and address technical issues.</li>
              </ul>
              <p className="privacy_p">3. Disclosure Of Data</p>
              <p>
                We do not share your personal information with third parties, except when required to provide and improve the service, or when legally obligated
                to do so.
              </p>
              <p className="privacy_p">4. Security Of Data</p>
              <p>
                We prioritize the security of your data. We implement robust security measures to protect your personal information from unauthorized access,
                alteration, disclosure, or destruction. However, no method of transmission or storage is 100% secure, and we cannot guarantee absolute security.
              </p>
              <p className="privacy_p">5. Changes To This Privacy Policy</p>
              <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
              <p className="privacy_p">6. Contact Us</p>
              <p>
                If you have any questions about this Privacy Policy or our handling of your personal information, please contact us at: Email: [info@khub.biz]
              </p>
              <p className="privacy_p">7. Consent</p>
              <p>By using KHUB, you consent to our Privacy Policy and agree to its terms. If you do not agree with our policies, please do not use KHUB.</p>
            </div>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={() => {
              onHide();
            }}
            className="btn btn-light btn-elevate"
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PrivacyModal;
